module.exports = __webpack_public_path__ + "static/media/dot_FC4491_a.dce81945.svg";